var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "inline-confirmation-dialog" },
    [
      _c("keep-alive", [
        !_vm.value
          ? _c("div", [_vm._t("default")], 2)
          : _c(
              "form",
              {
                attrs: { novalidate: "", disabled: _vm.disabled },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.value,
                        expression: "value"
                      }
                    ],
                    staticClass:
                      "p-15 col-md-offset-3 col-sm-offset-3 col-sm-8 col-md-6"
                  },
                  [
                    _c(
                      "h2",
                      [
                        _vm._t("title", function() {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.title) +
                                "\n          "
                            )
                          ]
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", [_vm._t("dialog")], 2),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "m-t-40" },
                      [
                        _c(
                          "PrimaryButton",
                          {
                            attrs: {
                              size: "sm",
                              type: "submit",
                              "show-loader-on-form": _vm.submitting,
                              disabled: _vm.disabled
                            }
                          },
                          [
                            _vm._t("submit-title", function() {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.submitText) +
                                    "\n            "
                                )
                              ]
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-danger m-l-15 ng-scope ng-binding",
                            attrs: { type: "button", translate: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onCancel.apply(null, arguments)
                              }
                            }
                          },
                          [
                            _vm._t("cancel-title", function() {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.cancelText) +
                                    "\n            "
                                )
                              ]
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ]
                )
              ]
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }